import HarPrisContent from "../Priser/HarPrisContent";

const HarPriser = () => {

    return(
        <>
            <h2 className="priserHeader">Hår, Bryn & Vipper Priser</h2>
            <div className="priserCon">
                <HarPrisContent className="prisContentCon" />
            </div>
        </>
    )
}

export default HarPriser;